import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  // Example: get token from localStorage
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/" replace />; // redirect to login
  }

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const isEmployee = payload.role === 'employee';
    const path = window.location.pathname;
    if (isEmployee && path !== '/booking-management') {
      return <Navigate to="/booking-management" replace />;
    }
  } catch { localStorage.removeItem('token'); return <Navigate to="/" replace />; }
  return children;
};

export default PrivateRoute;
